import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=efab78ac&"
import script from "./UserNav.vue?vue&type=script&lang=js&"
export * from "./UserNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports